var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgPingjia = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React.createElement("rect", { x: 2.86151, y: 2.85992, width: 10.2801, height: 10.2801, rx: 1.94005, fill: "#00A5A4", stroke: "#00A5A4", strokeWidth: 2.51989 }));
export { SvgPingjia as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMi44NjE1MSIgeT0iMi44NTk5MiIgd2lkdGg9IjEwLjI4MDEiIGhlaWdodD0iMTAuMjgwMSIgcng9IjEuOTQwMDUiIGZpbGw9IiMwMEE1QTQiIHN0cm9rZT0iIzAwQTVBNCIgc3Ryb2tlLXdpZHRoPSIyLjUxOTg5Ii8+Cjwvc3ZnPgo=";
